import { render, staticRenderFns } from "./switchissuemethod.vue?vue&type=template&id=e0b470ea&scoped=true"
import script from "./switchissuemethod.vue?vue&type=script&lang=js"
export * from "./switchissuemethod.vue?vue&type=script&lang=js"
import style0 from "./switchissuemethod.vue?vue&type=style&index=0&id=e0b470ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b470ea",
  null
  
)

export default component.exports